import { useQuery } from '@tanstack/react-query';
import { isPosthogEnabled } from '../../../services/posthog/config';
import { DEFAULT_LIKELY_TO_FILL_BANDS } from '../likelyToFill';
import { JobsService } from '../services';

/**
 * The office's arm of the Likely to Fill test and its bands. Disabled until an
 * office is picked, and while PostHog is off, which leaves every office on
 * control (today's picker, no label).
 *
 * @param {string} [officeId] - Office (dentist) user id
 */
export const useLikelyToFillExperiment = (officeId) => {
  const { data, isLoading } = useQuery({
    queryKey: ['likelyToFillVariant', officeId],
    queryFn: () => JobsService.getLikelyToFillExperiment(officeId),
    enabled: !!officeId && isPosthogEnabled(),
    staleTime: 1000 * 60 * 5,
    retry: false,
  });

  return {
    isTreatment: data?.variant === 'treatment',
    bands: data?.bands ?? DEFAULT_LIKELY_TO_FILL_BANDS,
    isLoading,
  };
};
